var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: _vm.displayWidth + 'px', height: _vm.displayHeight + 'px'})},[_c('canvas',{ref:"canvas",class:{ waiting: _vm.waiting || _vm.dirty, ready: !_vm.waiting && !_vm.dirty },attrs:{"width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a91f88f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Sample.vue
// module id = 159
// module chunks = 1